module.exports = __webpack_public_path__ + "static/media/thomson_logo.79e75b0d.png";